import React, { useEffect, useState } from 'react';
import { MdOutlineAddBox } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useCurrent, useDelete, useFetch } from '../../../hooks';
import {
    ConfirmDelete,
    MwButton,
    MwSpinnerButton,
} from '../../ui';
import NoDataFound from '../../ui/NoDataFound';
import CardHeadeWithActions from '../../ui/CardHeadeWithActions';
import ListGroupsItem from './ListGroupsItem';

const ListGroups = ({ setMode, idItemSelected, setIdItemSelected }) => {
    const { t } = useTranslation('global');
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
    const {
        data: groups,
        loading: loadingGroups,
        refreshHandler,
    } = useFetch(
        `${process.env.REACT_APP_VENDORS_API_BASE_URL}/groups/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
    );
    const { data: resulltDelete, deleteItem } = useDelete();

    const editHandeler = (id) => {
        setIdItemSelected(id);
        setMode('Edit');
    };

    const deleteHandeler = (id) => {
        setIdItemSelected(id);
        setShowConfirmDelete(true);
    };

    const confirmDeleteHandller = () => {
        deleteItem(`${process.env.REACT_APP_VENDORS_API_BASE_URL}/groups/delete/${idItemSelected}`);
    };

    useEffect(() => {
        if (resulltDelete) {
            refreshHandler();
            setShowConfirmDelete(false);
        }
    }, [refreshHandler, resulltDelete]);

    return (
        <>
            <ConfirmDelete
                onDeleteHandler={confirmDeleteHandller}
                msg={t('customerGroups.confirmDelete')}
                onShow={showConfirmDelete}
                setOnShow={setShowConfirmDelete}
            />

            <div>
                <CardHeadeWithActions title={t('vendors.vendorGroups')}>
                    <MwButton inGroup={true} type='saveBtn' onClick={() => setMode('Add')}>
                        <MdOutlineAddBox size={18} />
                        <span>{t('customerGroups.addNewGroup')}</span>
                    </MwButton>
                </CardHeadeWithActions>

                <div className='py-3'>
                    {!loadingGroups && groups?.data?.length > 0 ? (
                        <div className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm'>
                            <div className='max-h-[calc(100vh-280px)] overflow-auto custom-scrollbar'>
                                <table className='min-w-[760px] w-full border-collapse'>
                                    <thead className='sticky top-0 z-10 bg-slate-100 text-xs uppercase tracking-wide text-slate-500'>
                                        <tr>
                                            <th className='px-3 py-3 text-center font-semibold'>#</th>
                                            <th className='px-3 py-3 text-start font-semibold'>
                                                {t('customerGroups.groupName')}
                                            </th>
                                            <th className='px-3 py-3 text-start font-semibold'>
                                                {t('customerGroups.groupDescription')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('product.status')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('table.actions')}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {groups.data.map((item, index) => (
                                            <ListGroupsItem
                                                key={item._id}
                                                index={index + 1}
                                                item={item}
                                                editHandeler={editHandeler}
                                                deleteHandeler={deleteHandeler}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : groups && groups?.data?.length < 1 ? (
                        <NoDataFound msg={t('customerGroups.noGroupsFound')} />
                    ) : (
                        <MwSpinnerButton withLabel={false} isFullCenter={true} />
                    )}
                </div>
            </div>
        </>
    );
};

export default ListGroups;
